import {createTheme} from "@mui/material";
import {Theme} from "@mui/material/styles";
import {DefaultTheme} from "styled-components";

const themeObject = {
	color: {
		primary: "#202020",
		secondary: "#000000",
		tertiary: "#C51A20",
		menu: "#ffffff",
		question1: "#ffffff",
		questionCounter: "#202020",
		footer: "#ffffff",
		footerLink: "#676767",
		header: "#ffffff",
		headerLinkHover: "#1c1c1c",
		headerSubLinksItemTitle: "#b5262f",
		headerSubLink: "#1c1c1c",
		headerSubLinkHover: "#b5262f",
	},
	background: {
		primary: "#A408A4",
		menu: "#C51A20",
		tertiary: "#00FFFF",
		activeMenu: "#931A20",
		question1: "#545456",
		squadListHeader: "#FF00FF",
		questionCounter: "#FF00FF",
		question1Active: "#444444",
		footer: "#202020",
		form: "#ffffff",
		header: "#191919",
		headerLinkHover: "#f0f0f0",
		mobileNavigation: "#1c1c1c",
		mobileIconHover: "#b5262f",
		mobileLinkActive: "#575757",
	},
	button: {
		primary: {
			color: "#202020",
			background: "#FF00FF",
			borderColor: "#FF00FF",
			disabledColor: "#ffffff",
			disabledBackground: "#bcbcbc",
			disabledBorderColor: "#bcbcbc",
			hoverColor: "#202020",
			hoverBackground: "#A408A4",
			hoverBorderColor: "#A408A4",
			fontWeight: "bold",
		},
		secondary: {
			color: "#202020",
			background: "#00FFFF",
			borderColor: "#00FFFF",
			disabledColor: "#202020",
			disabledBackground: "#4babab",
			disabledBorderColor: "#4babab",
			hoverColor: "#202020",
			hoverBackground: "#068080",
			hoverBorderColor: "#068080",
			fontWeight: "bold",
		},

		primaryDark: {
			color: "#202020",
			background: "#FF00FF",
			borderColor: "#FF00FF",
			disabledColor: "#878789",
			disabledBackground: "#444446",
			disabledBorderColor: "#444446",
			hoverColor: "#202020",
			hoverBackground: "#A408A4",
			hoverBorderColor: "#A408A4",
			fontWeight: "bold",
		},
	},
	breakpoints: {
		values: {
			small_mobile: 425,
			mobile: 768,
			tablet: 960,
			desktop: 1200,
			large_desktop: 1440,
		},
	},
};

export const theme = createTheme(themeObject) as unknown as DefaultTheme;
type ThemeInterface = typeof themeObject;

/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/naming-convention */

declare module "@mui/material/styles" {
	interface Theme extends ThemeInterface {}

	interface BreakpointOverrides {
		xs: false; // removes the `xs` breakpoint
		sm: false;
		md: false;
		lg: false;
		xl: false;
		small_mobile: true; // adds the `mobile` breakpoint
		mobile: true; // adds the `mobile` breakpoint
		tablet: true;
		desktop: true;
		large_desktop: true;
	}
}

declare module "styled-components" {
	export interface DefaultTheme extends Theme {}
}
